module.exports = __webpack_public_path__ + "static/media/tvLogo.9cc6b642.svg";